import { useMemo } from 'react';
import { useEnv, useProject, useToken } from '@adsk/bim360-matrix-react-api';

const cachedPlugins = {};

const getContainerId = (project, containerType) => {
  const container =
    project && project.containers ? project.containers.find(s => s.type === containerType) : null;
  return container ? container.id : null;
};

const getOrCreatePlugin = (pluginFactory, project, env, region, getToken) => {
  const { entityType, metadata } = pluginFactory;
  const projectId = project.id;
  const key = `${entityType}-${projectId}`;
  if (cachedPlugins[key]) {
    return cachedPlugins[key];
  }
  let containerId;
  const { containerType } = metadata;
  if (containerType) {
    containerId = getContainerId(project, containerType);
    if (!containerId) {
      throw new Error(
        `EntityPickerModalContainer - Cannot find container for type: ${containerType}`
      );
    }
  }
  const config = {
    env,
    region,
    projectId,
    getToken
  };
  if (containerId) {
    config.containerId = containerId;
  }
  cachedPlugins[key] = pluginFactory.createPlugin(config);
  return cachedPlugins[key];
};

export default plugins => {
  const { env, region } = useEnv();
  const project = useProject();
  const { getToken } = useToken();

  const entityTypesArr = plugins.map(p => p.entityType);
  const joinedEntityTypes = entityTypesArr ? entityTypesArr.join(',') : entityTypesArr;
  // Disable as array check is done by reference. We want to change the value only if `entityTypes` content changes.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const entityTypes = useMemo(() => entityTypesArr, [joinedEntityTypes]);

  const typeToPlugin = useMemo(
    () =>
      project && plugins
        ? plugins.reduce((res, p) => {
          res[p.entityType] = getOrCreatePlugin(p, project, env, region, getToken);
          return res;
        }, {})
        : {},
    // Disable as array check is done by reference. We don't want to recalculate if `plugins` array used as literal.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [env, region, project, entityTypes, getToken]
  );

  return {
    typeToPlugin,
    entityTypes
  };
};
